<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Client Details</h1>
    <p>Please provide the details for the new client.</p>
  </div>

  <div class="cell small-6">
    <form class="fieldset" @submit.prevent>
      <label>Company Name</label>
      <input
        type="text"
        id="clientName"
        name="clientName"
        placeholder=""
        v-model="formData.clientName"
        maxlength="35"
        required
      />

      <label>Address Line 1</label>
      <input
        type="text"
        id="addressLine1"
        name="addressLine1"
        placeholder=""
        v-model="formData.address.addressLine1"
        maxlength="35"
        required
      />

            <label>Address Line 2</label>
      <input
        type="text"
        id="addressLine2"
        name="addressLine2"
        placeholder=""
        v-model="formData.address.addressLine2"
        maxlength="35"
        required
      />


            <label>Address Line 3</label>
      <input
        type="text"
        id="addressLine3"
        name="addressLine3"
        placeholder=""
        v-model="formData.address.addressLine3"
        maxlength="35"
      
      />

            <label>Address Line 4</label>
      <input
        type="text"
        id="addressLine4"
        name="addressLine4"
        placeholder=""
        v-model="formData.address.addressLine4"
        maxlength="35"
      
      />

        <div class="grid-x grid-margin-x" >
        <div class="cell small-8">
            <CountrySelect v-model:country="formData.address.country" />
      </div>
      </div>
      <div class="grid-x grid-margin-x" >
        <div class="cell small-6">
                <label>Postcode</label>
          <input
            type="text"
            id="postcode"
            name="postcode"
            placeholder=""
            v-model="formData.address.postcode"
            maxlength="35"
            
          />
        </div>
      </div>

        <label for="industry">Client Industry</label>
        <select
          id="industry"
          v-model="props.formData.industry"
          required
        >
          <option disabled>
            Please select an option
          </option>
          <option
            v-for="opt in CUSTOMER_INDUSTRIES"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </option>
        </select>
    </form>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { CUSTOMER_INDUSTRIES } from '@/helpers/constants.js'
import CountrySelect from '@/components/CountrySelect.vue'

const error = ref([])

const props = defineProps({
  formData: Object
})

// Your rule (as written):
// validate + show First/Surname/Email ONLY if isOnboardingViaIntermediary == false
const showOnboardingContactFields = computed(() => props.formData?.isOnboardingViaIntermediary === false)

const isBlank = (v) => String(v ?? '').trim().length === 0

const isValidEmail = (email) => {
  const e = String(email ?? '').trim()
  // simple + solid email regex for typical validation
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
}

const validateStep = () => {
  error.value = []

  const fd = props.formData
  const addr = fd?.address ?? {}

  const country = String(addr.country ?? '').trim()
  const postcode = String(addr.postcode ?? '').trim()

  // Always required
  if (isBlank(fd?.clientName)) {
    error.value.push('Company Name is required.')
  }
  if (isBlank(addr.addressLine1)) {
    error.value.push('Address Line 1 is required.')
  }
  if (isBlank(addr.addressLine2)) {
    error.value.push('Address Line 2 is required.')
  }

  // Country required
  if (isBlank(country)) {
    error.value.push('Country is required.')
  }

  // Postcode required only for UK
  if (country === 'United Kingdom' && isBlank(postcode)) {
    error.value.push('Postcode is required when Country is United Kingdom.')
  }

  // Conditional: if Line 4 is provided, Line 3 must be provided
  if (!isBlank(addr.addressLine4) && isBlank(addr.addressLine3)) {
    error.value.push('Address Line 3 is required when Address Line 4 is provided.')
  }

  // Industry required
  if (isBlank(fd?.industry)) {
    error.value.push('Client Industry is required.')
  }

  return error.value.length === 0
}



const executeStep = async () => true

defineExpose({ validateStep, executeStep })
</script>
